import { render, staticRenderFns } from "./idValidate.vue?vue&type=template&id=850d4bc4&scoped=true"
import script from "./idValidate.vue?vue&type=script&lang=js"
export * from "./idValidate.vue?vue&type=script&lang=js"
import style0 from "./idValidate.vue?vue&type=style&index=0&id=850d4bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850d4bc4",
  null
  
)

export default component.exports